import restService from './restService'

export default {
  getActive (includeFinished) {
    if (includeFinished) {
      return restService.execute('get', '/v1/contracts/all/web/includefinished')
    } else {
      return restService.execute('get', '/v1/contracts/all/web')
    }
  },
  get (id) {
    return restService.execute('get', `/v1/contracts/${id}`)
  },
  create (data) {
    return restService.execute('post', '/v1/contracts', data)
  },
  update (id, data) {
    return restService.execute('put', `/v1/contracts/${id}`, data)
  },
  delete (id) {
    return restService.execute('delete', `/v1/contracts/${id}`)
  },
}
